{
  "collectionLabel": "مقترحات"
}
